"use client";

import { useMemo } from "react";
import { useQueryStates } from "nuqs";

import {
  isCustomUmrahSource,
  parseCustomUmrahCityKey,
} from "../custom-umrah-flow";
import { customUmrahFlowParams } from "../params";

export function useSearchServiceFlow() {
  const [{ source, umrah_city }] = useQueryStates(customUmrahFlowParams, {
    shallow: true,
  });

  return useMemo(() => {
    const umrahCity = parseCustomUmrahCityKey(umrah_city);

    return {
      isCustomUmrahFlow: isCustomUmrahSource(source) && Boolean(umrahCity),
      source,
      umrahCity,
    };
  }, [source, umrah_city]);
}
